export default __webpack_public_path__ + "static/media/warning.70df0e24.svg";